import React from "react";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
  IconContainer
} from "./Header.styled";
import { Typography, Button, Icon } from "@ann/web-components";
import { useNavigate } from "react-router-dom";
import { useAutosaveContext } from "../../../../../../../context/AutosaveContext";

const Header = ({ triggerName, retrySave, hasUnsavedChanges, isSaving, saveImmediately }) => {
  const navigate = useNavigate();
  const { globalError } = useAutosaveContext();

  const handleBackClick = () => {
    // Save changes before navigating back
    if (hasUnsavedChanges && saveImmediately) {
      saveImmediately();
    }
    navigate("/v2/workflows");
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <IconContainer onClick={handleBackClick}>
          <Icon name="arrowLeft" size="medium" />
        </IconContainer>
        <TypographyContainer>
          <Typography category="title" size="large" weight="bold">
            {triggerName || "New Trigger"}
          </Typography>
        </TypographyContainer>
      </HeaderLeftContainer>

      <HeaderRightContainer>
        {globalError && hasUnsavedChanges && (
          <Button
            label={isSaving ? "Saving..." : "Retry save"}
            size="medium"
            type="secondary"
            disabled={isSaving}
            onClick={retrySave}
          />
        )}
        <Button
          label="Publish"
          size="medium"
          type="primary"
          disabled={true}
        />
      </HeaderRightContainer>
    </HeaderContainer>
  );
};

export default Header;
